module.exports = __webpack_public_path__ + "static/media/SM-MT2-TRIAL-if-wrong.78785124.mp3";